/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-15 14:48:37
 * @Description:
 */
// 根据menuDto生成前端菜单对象,并包含各级子菜单
export function convertMenuDto(menuDto, allMenuDtos) {
  const menu = {
    id: menuDto.id,
    name: menuDto.funcName,
    icon: menuDto.property1,
    path: menuDto.funcUrl ? menuDto.funcUrl.trim() : ''
  }

  // 查找子集
  const childrenDtos = allMenuDtos.filter((item) => item.parentId === menu.id)
  if (childrenDtos.length > 0) {
    const children = childrenDtos.map((item) =>
      convertMenuDto(item, allMenuDtos)
    )
    menu.children = children
  }
  return menu
}

export function convertToNavmenu(menuDto) {
  const menu = {
    id: menuDto.MENUID,
    name: menuDto.MENUNAME,
    icon: menuDto.PIC,
    path: menuDto.URL ? menuDto.URL.trim() : '',
    fullPath: menuDto.URL ? menuDto.URL.trim() : menuDto.MENUID
  }

  // 处理子集
  if (menuDto.Children && menuDto.Children.length > 0) {
    const childrenMenus = menuDto.Children.map((item) => convertToNavmenu(item))
    menu.children = childrenMenus
  }
  return menu
}
